import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { AdminAPI } from '../api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Already logged in?
  if (AdminAPI.isLoggedIn()) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const ok = await AdminAPI.login(password.trim());
      if (ok) {
        navigate('/admin', { replace: true });
      } else {
        setError('Mot de passe incorrect.');
      }
    } catch (err) {
      setError(err.message || 'Erreur inattendue.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-gray-50">
      <div className="w-full max-w-md bg-white shadow-lg border border-gray-100 p-8 md:p-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-[#8b2c3f] text-white flex items-center justify-center">
            <Lock size={20} />
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest text-gray-500">Administration</div>
            <h1 className="text-2xl font-black text-gray-900" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
              Espace privé
            </h1>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          Entrez le mot de passe administrateur pour gérer les histoires du site.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[11px] uppercase font-bold tracking-wider text-gray-700 mb-2">
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              className="w-full border border-gray-300 focus:border-[#8b2c3f] focus:ring-1 focus:ring-[#8b2c3f] outline-none px-4 py-3 text-gray-900"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password.trim()}
            className="w-full bg-gray-900 hover:bg-[#8b2c3f] text-white font-bold text-[13px] uppercase tracking-widest px-6 py-3 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <LogIn size={16} />
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
